import { put, select, takeLatest } from 'redux-saga/effects'
import { DriversLicenseScannerConstants } from '../store/driversLicenseScanner.constants'
import { getDriversLicenseScannerSelector } from '../selectors'
import { IPatientDemographicsState } from '../../patientDemographics/store/patientDemographics.types'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors'
import {
  savePatientDemographics,
  setPatientDemographics,
} from '../../patientDemographics/store/patientDemographics.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { DriversLicenseScannerService } from '../services/driversLicenseScanner.service'
import { IDriversLicenseScannerState } from '../store/driversLicenseScanner.types'
import { IPatientDemographicsOptionsState } from '../../options/store/options.types'
import { getPatientDemographicsOptionsSelector } from '../../options/selectors'
import { clearValidationErrorsByPathList } from '../../../utilities/runRulesValidation.util'
import { IRulesState } from '../../rules/store/rules.types'
import { getRulesSelector } from '../../rules/selectors'
import { getTimesSelector } from '../../times/selectors'

export function* importDriversLicenseInfo() {
  try {
    const pd: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
    const pdo: IPatientDemographicsOptionsState = yield select(getPatientDemographicsOptionsSelector)
    const dlScanner: IDriversLicenseScannerState = yield select(getDriversLicenseScannerSelector)
    const { dispatchedDate } = yield select(getTimesSelector)
    const driversLicenseScannerService = new DriversLicenseScannerService()
    const rules: IRulesState = yield select(getRulesSelector)

    rules.errors = clearValidationErrorsByPathList(rules.errors, ['patientDemographics'])
    driversLicenseScannerService.transformDriverLicenseInfo(pd, pdo, dlScanner, dispatchedDate)

    yield put(setPatientDemographics(pd))
    yield put(savePatientDemographics())
  } catch (e) {
    yield put(throwPcrException(`importDriversLicenseInfo() error: ${e}`))
  }
}

export function* importDriversLicenseInfoSaga() {
  yield takeLatest([DriversLicenseScannerConstants.IMPORT_DRIVERS_LICENSE_INFO], importDriversLicenseInfo)
}
